import { render, staticRenderFns } from "./DocListagemExibicao.vue?vue&type=template&id=3ca02f40&scoped=true&lang=pug&"
import script from "./DocListagemExibicao.vue?vue&type=script&lang=js&"
export * from "./DocListagemExibicao.vue?vue&type=script&lang=js&"
import style0 from "./DocListagemExibicao.vue?vue&type=style&index=0&id=3ca02f40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca02f40",
  null
  
)

export default component.exports